import React from 'react';
import IconSideNav from './Navbar/Navbar';
import ProjectsPage from './Projects/Projects/Proyects'

const Projects = ({ key }) => {
    return (
        <>
            <IconSideNav />
            <ProjectsPage />
        </>
    );
}

export default Projects;
